<div class="blank-container view-content-container">

  <div class="blank-container-box">

    <iframe id="fileIframe"></iframe>

  </div>

</div>
